import BossClient from './boss-client';
/**
 *
 * @description 用于多boss复报
 */
export default class BossGroupClient {
    constructor(configs) {
        this.clients = [];
        this.clients = configs.map(config => new BossClient(config));
    }
    report(params, event) {
        this.clients.forEach(client => client.report(params, event));
    }
}
